import React from 'react'

const ArrowDropdownIcon14pxSvg = (props) => {
    return (
        <svg 
        {...props}
        width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g id="vuesax/bold/arrow-down">
                <g id="arrow-down">
                    <path id="Vector" d="M10.4534 4.77167H6.81926H3.54676C2.98676 4.77167 2.70676 5.44833 3.10343 5.845L6.1251 8.86667C6.60926 9.35083 7.39676 9.35083 7.88093 8.86667L9.0301 7.7175L10.9026 5.845C11.2934 5.44833 11.0134 4.77167 10.4534 4.77167Z" fill="currentColor" />
                </g>
            </g>
        </svg>

    )
}

export default ArrowDropdownIcon14pxSvg